import type { ProjectMember } from '../../auth/types.ts';

export type CommunicationRecipientAppUserStatus = 'app-user' | 'no-app-user' | 'external';

export function activeAppUserPersonnelIds(
  members: ProjectMember[],
  currentMember?: ProjectMember | null
): Set<string> {
  const activeIds = new Set<string>();

  for (const member of [...members, ...(currentMember ? [currentMember] : [])]) {
    if (member.status === 'active' && member.personnelId) {
      activeIds.add(member.personnelId);
    }
  }

  return activeIds;
}

export function appUserStatusForPersonnelId(
  personnelId: string | undefined,
  activePersonnelIds: ReadonlySet<string>
): CommunicationRecipientAppUserStatus {
  if (!personnelId) {
    return 'external';
  }

  return activePersonnelIds.has(personnelId) ? 'app-user' : 'no-app-user';
}

export function appUserStatusLabel(status: CommunicationRecipientAppUserStatus): string {
  return {
    'app-user': 'App user',
    'no-app-user': 'No app user',
    external: 'External',
  }[status];
}
